import * as React from 'react';
import { css, classNamesFunction } from 'office-ui-fabric-react/lib/Utilities';
import { ActivityItem } from '../ActivityItem';
import { getStyles, IActivityItemExampleStyleProps, IActivityItemExampleStyles } from './ActivityItem.Example.styles';
import { Icon } from '../../../Icon';
import { Link } from '../../../Link';

export class ActivityItemBasicExample extends React.Component<React.Props<ActivityItemBasicExample>, {}> {
  public render(): JSX.Element {
    const getClassNames = classNamesFunction<IActivityItemExampleStyleProps, IActivityItemExampleStyles>();
    const classNames = getClassNames(getStyles, {});

    // tslint:disable:jsx-no-lambda
    const activityItemExamples = [
      {
        key: 1,
        activityDescription: [
          <Link
            key={1}
            className={css(classNames.nameText)}
            onClick={() => {
              alert('A name was clicked.');
            }}
          >
            Philippe Lampros
          </Link>,
          <span key={2}> commented</span>
        ],
        activityIcon: <Icon iconName={'Message'} />,
        comments: [
          <span key={1}>Hello! I am making a comment and mentioning </span>,
          <Link
            key={2}
            className={css(classNames.nameText)}
            onClick={() => {
              alert('An @mentioned name was clicked.');
            }}
          >
            @Anđela Debeljak
          </Link>,
          <span key={3}> in the text of the comment.</span>
        ],
        timeStamp: 'Just now'
      },
      {
        key: 2,
        activityDescription: [
          <Link
            key={1}
            className={css(classNames.nameText)}
            onClick={() => {
              alert('A name was clicked.');
            }}
          >
            Lisha Refai
          </Link>,
          <span key={2}> deleted </span>,
          <span key={3} className={css(classNames.nameText)}>
            DocumentTitle.docx
          </span>
        ],
        activityIcon: <Icon iconName={'Trash'} />,
        timeStamp: '2 hours ago'
      },
      {
        key: 3,
        activityDescription: [
          <Link
            key={1}
            className={css(classNames.nameText)}
            onClick={() => {
              alert('A name was clicked.');
            }}
          >
            Julian Arvidsson
          </Link>,
          <span key={2}> moved </span>,
          <Link
            key={3}
            className={css(classNames.nameText)}
            onClick={() => {
              alert('A document was clicked.');
            }}
          >
            PresentationTitle.pptx
          </Link>,
          <span key={4}> to </span>,
          <Link
            key={5}
            className={css(classNames.nameText)}
            onClick={() => {
              alert('A folder was clicked.');
            }}
          >
            Destination Folder
          </Link>
        ],
        activityIcon: <Icon iconName={'FabricMovetoFolder'} />,
        timeStamp: 'Yesterday'
      }
    ];

    const activityExampleList: Array<JSX.Element> = [];
    activityItemExamples.forEach((item: { key: string | number }) => {
      const props = item;
      activityExampleList.push(<ActivityItem {...props} key={item.key} className={css(classNames.exampleRoot)} />);
    });

    return <div>{activityExampleList}</div>;
  }
}
